module.exports = __webpack_public_path__ + "static/1-You Will Be Loved_installation-17d785e8517175c53981e575ad58eeae.jpg";